import {
  controlDevice,
  deleteDevice,
  getAlarm,
  getDeviceTable,
  getRoomIds,
  refreshAllDevice,
  repairDevice,
  setAlarm
} from '../services/monitor';
import { Modal } from 'antd';
import { findAllZone } from '../services/account';
import { initialSockJS } from '../utils/sockutil';
import { PATHS } from '../utils/constants';

export default {
  namespace: 'monitor',
  state: {
    devicesData: [],
    zoneIdData: '',
    statusData: 'all',
    deviceLoading: [],
    configData: {}
  },
  reducers: {
    setDevices(state, { devicesData }) {
      return { ...state, devicesData };
    },
    setZoneId(state, { zoneIdData }) {
      return { ...state, zoneIdData };
    },
    setStatus(state, { statusData }) {
      return { ...state, statusData };
    },
    setDeviceLoading(state, { deviceLoading }) {
      return { ...state, deviceLoading };
    },
    setConfig(state, { configData }) {
      return { ...state, configData };
    }
  },
  effects: {
    *getAllRoomDeviceStatus({}, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      let filter = { locale, flag: 1 };
      let res = yield call(findAllZone, { filter });
      if (res.status === 0 && res.data) {
        yield put({ type: 'account/changeAreaData', areaData: res.data });
        yield put({ type: 'getRoomByArea', zoneId: res.data.id || '' });
      }
    },
    *getRoomByArea({ zoneId }, { call, put, select }) {
      const { locale } = yield select(state => state.i18n);
      const data = yield call(getRoomIds, { locale, zoneId });
      if (data.status === 0) {
        yield put({ type: 'setZoneId', zoneIdData: zoneId });
        yield put({ type: 'getDeviceStatus', rooms: data.data });
      }
    },
    *getDeviceStatus({ rooms }, { call, put, select }) {
      const { locale } = yield select(state => state.i18n);
      const { statusData } = yield select(state => state.monitor);
      if (rooms && rooms.length > 0) {
        let roomIds = [];
        rooms.map(room => {
          roomIds.push({ roomId: room.id, roomName: room.name, roomNameEn:room.nameEn});
        });
        const data = yield call(getDeviceTable, {
          locale,
          status: statusData,
          roomIds: roomIds
        });
        if (data.status === 0) {
          yield put({ type: 'setDevices', devicesData: data.data });
        }
      } else {
        yield put({ type: 'setDevices', devicesData: [] });
      }
    },
    *deviceAction({ device }, { call, put, select }) {
      const { locale, messages } = yield select(state => state.i18n);
      const data = yield call(controlDevice, { locale, device });
      if (data.status !== 0) {
        yield put({
          type: 'deviceLoading',
          uniqueId: device.uniqueId,
          value: 'delete'
        });
        Modal.error({
          title: data.msg,
          okText: messages['modal_manage_btn_ok']
        });
      }
    },
    *deviceRepair({ device }, { call, put, select }) {
      const { locale, messages } = yield select(state => state.i18n);
      const data = yield call(repairDevice, { locale, device });
      if (data.status !== 0) {
        yield put({
          type: 'deviceLoading',
          uniqueId: device.uniqueId,
          value: 'delete'
        });
        Modal.error({
          title: data.msg,
          okText: messages['modal_manage_btn_ok']
        });
      }
    },
    *refreshAll({}, { call, select }) {
      const { locale } = yield select(state => state.i18n);
      yield call(refreshAllDevice, { locale });
    },
    *unBindDevice({ device }, { call, put, select }) {
      const { locale, messages } = yield select(state => state.i18n);
      const data = yield call(deleteDevice, { locale, device });
      if (data.status === 0) {
        const { zoneIdData } = yield select(state => state.monitor);
        yield put({ type: 'getRoomByArea', zoneId: zoneIdData });
      } else {
        Modal.error({
          title: data.msg,
          okText: messages['modal_manage_btn_ok']
        });
      }
    },
    *deviceLoading({ uniqueId, value }, { put, select }) {
      const { deviceLoading } = yield select(state => state.monitor);
      if (deviceLoading) {
        let index = -1;
        deviceLoading.map((item, i) => {
          if (item === uniqueId) index = i;
        });
        if (index < 0 && value === 'add') {
          deviceLoading.push(uniqueId);
        } else if (index >= 0 && value === 'delete') {
          deviceLoading.splice(index, 1);
        }
      }
      yield put({ type: 'setDeviceLoading', deviceLoading: deviceLoading });
    },
    *socketMessage({ message }, { put, select }) {
      if (message && message.device) {
        yield put({
          type: 'deviceLoading',
          uniqueId: message.device.uniqueId,
          value: 'delete'
        });
      }
      const { zoneIdData } = yield select(state => state.monitor);
      if (zoneIdData) {
        yield put({ type: 'getRoomByArea', zoneId: zoneIdData });
      }
    },
    *getAlarmConfig({}, { call, put, select }) {
      const { locale } = yield select(state => state.i18n);
      const data = yield call(getAlarm, { locale });
      if (data.status === 0) {
        yield put({ type: 'setConfig', configData: data.data });
      }
    },
    *setAlarmConfig({ config }, { call, select }) {
      const { locale, messages } = yield select(state => state.i18n);
      const data = yield call(setAlarm, { locale, config });
      if (data.status === 0) {
        Modal.success({
          title: messages['index_save_success'],
          okText: messages['modal_manage_btn_ok']
        });
      } else {
        Modal.error({
          title: data.msg,
          okText: messages['modal_manage_btn_ok']
        });
      }
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === PATHS.boardMonitor) {
          initialSockJS(dispatch, '');
          dispatch({ type: 'getAllRoomDeviceStatus' });
        }
        if (pathname.indexOf('controlBoard/alarm') > -1) {
          dispatch({ type: 'getAlarmConfig' });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/monitor.js